import { signal } from "@preact/signals-react"

export const filterComponents = signal([])
export const commonFilterErrors = signal([])
export const areCommonFiltersValid = signal(false)